module.exports = __webpack_public_path__ + "static/media/om_beard_stubble_diamond_chestnut.68703645.png";